import dayjs from 'dayjs';
import { useContext } from 'react';
import { CountryContext } from '../../components/common/Navigation/Navigation';

export const isEmpty = (obj) => {
  if (!obj || Object.keys(obj).length === 0) {
    return true;
  } else {
    return false;
  }
};
export const dateRange = (date) => {
  const range = date.map((d) => dayjs(d));
  return range;
};

export const handleError = (error) => {
  let errormsg = null;
  let statusCode = null;
  let errorCode = null;

  if (!error) {
    statusCode = 500;
    errormsg = 'Internal Server Error,please contact Appen for help';
    errorCode = 'APPEN_ERR_0001';
  } else if (error.response) {
    // Server responded a status outside the range of 2xx
    if (error.statusCode === 400) {
      statusCode = 400;
      errormsg = 'ValidationError,please contact Appen for help';
      errorCode = 'APPEN_ERR_0004';
    } else if (error.statusCode === 401) {
      statusCode = 401;
      errormsg = 'Unauthorized Error,please login again';
      errorCode = 'APPEN_ERR_0005';
    } else if (error.statusCode === 404) {
      statusCode = 404;
      errormsg = 'Resource not found,please login again';
      errorCode = 'APPEN_ERR_0006';
    } else {
      statusCode = error.statusCode || 500;
      errormsg = 'Internal Server Error,please contact Appen for help';
      errorCode = 'APPEN_ERR_0007';
    }
  } else if (error.request) {
    // Request was made, but no response received
    statusCode = 503;
    errormsg =
      'Network Error server is not ready to handle the request,please contact Appen for help';
    errorCode = 'APPEN_ERR_0002';
  } else {
    statusCode = 500;
    errormsg = 'Internal Server Error,please contact Appen for help';
    errorCode = 'APPEN_ERR_0003';
  }
  return alert(`${statusCode} <br /> ${errormsg} <br /> ${errorCode}`);
};

export const handlePayoutPeriod = (_date) => {
  let date = _date;
  if (_date) {
    const payoutPeriod = dayjs(_date);
    date = `${payoutPeriod.format('MMMM')}-${payoutPeriod.year()}`;
  }
  return date;
};

export const getPastMonthAndYear = () => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1); // Go back one month

  const month = today.getMonth() + 1; // getMonth() is 0-based
  const year = today.getFullYear();

  return { month, year };
};
